module.exports = __webpack_public_path__ + "img/57000.45d7e867.jpg";